<template>
  <div class="datatable">
    <div class="data" :style="{minHeight:minHeight}" :class="{viewtable:viewtype==='table'}">
      <Spin fix v-show="loading"></Spin>

      <!-- 表格模式 -->
      <table v-if="viewtype==='table'" :class="{allowscroll:maxHeight}">
        <thead class="thead">
          <tr v-if="th">
            <th v-for="(v,i) in th" :key="i" v-html="v"></th>
          </tr>
          <slot name="th" v-else></slot>
        </thead>
        <tbody v-if="!datalist&&!loading">
          <tr v-if="errmsg">
            <td class="msg" :colspan="th?th.length||colcount:colcount">{{errmsg}}</td>
          </tr>
        </tbody>
        <tbody v-if="datalist" :class="{scrollbar:maxHeight}" :style="tbodystyle">
          <tr v-if="!loading&&!datalist.length">
            <td class="msg" :colspan="th?th.length||colcount:colcount">{{tip||$t('msg.m1')}}</td>
          </tr>
          <slot v-for="v in datalist" :item="v" :list="datalist"></slot>
        </tbody>
      </table>

      <!-- 列表模式 -->
      <div v-if="viewtype==='list'">
        <div v-if="!datalist&&!loading" class="listmsg">{{errmsg}}</div>
        <div>
          <div v-if="!loading&&!datalist.length" class="listmsg">{{tip||$t('msg.m1')}}</div>
          <slot v-for="v in datalist" :item="v" :list="datalist"></slot>
        </div>
      </div>
    </div>
    <div class="gridpager" v-if="pageCount>1 && isShow==false">
      <div class="ctrl">
        <span @click="pagechange(1)">{{$t('nav.w28')}}</span>
        <span @click="pagechange(pageIndex-1)">{{$t('nav.w29')}}</span>
        <span
          v-for="n in pagearr"
          :key="n"
          :class="{'active':n==pageIndex}"
          @click="pagechange(n)"
        >{{n}}</span>
        <span @click="pagechange(pageIndex+1)">{{$t('nav.w30')}}</span>
        <span @click="pagechange(pageCount)">{{$t('nav.w31')}}</span>
      </div>
    </div>
    <div class="more" v-if="pageIndex < pageCount && pageCount>1 && isShow==true" @click="toMore">
      {{$t('nav.w85')}}
      <Icon type="ios-arrow-forward" />
    </div>
  </div>
</template>
<script>
// import { version } from "punycode";
// let toCheck = null;
export default {
  props: {
    static: {
      default: null,
    },
    th: {},
    url: {
      type: String,
      default: "",
    },
    filter: {
      type: Object,
      default: () => {
        return {};
      },
    },
    field: {
      type: String,
      default: "",
    },
    minHeight: {
      type: String,
      default: "300px",
    },
    maxHeight: {
      type: String,
      default: "",
    },
    colcount: {
      type: Number,
      default: 1,
    },
    viewtype: {
      type: String,
      default: "table",
    },
    tip: {
      // type: String,
      default: "",
    },
    isShow: {
      // type: String,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      datalist: null,
      pageIndex: 1,
      pageCount: 0,
      errmsg: "",
      showArr: [],
    };
  },
  watch: {
    static(v) {
      if (v) {
        this.datalist = v;
        this.loading = false;
      }
    },
    pageIndex(v) {
      if (this.isShow) {
        this.pageIndex = v;
        this.getMore();
      } else {
        this.getData();
      }
    },
    // filter(v) {
    //   console.log(v);
    //   if (this.pageIndex != 1) {
    //     this.pageIndex = 1;
    //   } else {
    //     this.getData();
    //   }
    // },
    filter: {
      handler(newName, oldName) {
        if (this.pageIndex != 1) {
          this.pageIndex = 1;
        } else {
          this.getData();
        }
      },
      deep: true,
    },
    isShow(v) {
      this.datalist = [];
      this.showArr = [];
      if (v) {
        this.getMore();
      } else {
        this.pageIndex = 1;
        this.getData();
      }
    },
  },
  mounted() {
    if (this.url) this.getData(1);
    if (this.static) {
      this.datalist = this.static;
      this.loading = false;
    }
  },
  methods: {
    toMore() {
      this.pageIndex += 1;
    },
    getMore() {
      this.loading = true;
      this.$axios
        .get(this.url, {
          params: {
            page: this.pageIndex,
            ...this.filter,
          },
        })
        .then((res) => {
          this.loading = false;
          if (res.err) {
            this.errmsg = res.msg;
          } else {
            if (res[this.field].length > 0) {
              res[this.field].map((o) => {
                if (this.showArr.indexOf(o) < 0) {
                  this.showArr.push(o);
                }
              });
              this.datalist = this.showArr
              let data = {
                LoanSchemeList: this.showArr,
                UnFinishedCount: res.UnFinishedCount,
              };
              this.$emit("on-data", data);
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.errmsg = this.$t("msg.m77");
        });
    },
    getData() {
      this.loading = true;
      this.$axios
        .get(this.url, {
          params: {
            page: this.pageIndex,
            ...this.filter,
          },
        })
        .then((res) => {
          this.$emit("on-data", res);
          this.loading = false;
          if (res.err) {
            this.errmsg = res.msg;
          } else {
            if (res[this.field]) {
              this.datalist = res[this.field]
              this.pageCount = res.Pager.PageCount;
            } else {
              this.datalist = res;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.errmsg = this.$t("msg.m77");
        });
    },
    pagechange(v) {
      if (this.loading) return;
      if (v < 1) this.pageIndex = 1;
      else if (v > this.pageCount) this.pageIndex = this.pageCount;
      else this.pageIndex = v;
    },
    refresh() {
      if (this.pageIndex == 1) this.getData();
      else this.pageIndex = 1;
    },
    tofresh() {
      this.showArr = [];
      this.datalist = [];
      if (this.pageIndex == 1) this.getMore();
      else this.pageIndex = 1;
    },
  },
  computed: {
    pagearr() {
      let arr = [];
      let pageIndex = this.pageIndex,
        pageCount = this.pageCount;
      if (pageCount < 2) {
        return [1];
      }
      let startidx = 1,
        endidx = pageCount;
      if (pageCount > 5) {
        if (pageIndex - 2 > 0 && pageIndex + 2 < pageCount) {
          startidx = pageIndex - 2;
          endidx = pageIndex + 2;
        } else if (pageIndex + 2 >= pageCount) {
          startidx = pageCount - 4;
          endidx = pageCount;
        } else if (pageIndex - 2 <= 0) {
          startidx = 1;
          endidx = 5;
        }
      }
      for (let i = startidx; i <= endidx; i++) {
        arr.push(i);
      }
      return arr;
    },
    tbodystyle() {
      if (this.maxHeight == "") return {};
      return {
        maxHeight: this.maxHeight,
      };
    },
  }
};
</script>
<style lang="less" scoped>
.datatable {
  font-size: 14px;
  .data {
    position: relative;
    &.viewtable {
      background: #fff;
      border-radius: 10px;
    }
  }
  table {
    width: 100%;
    text-align: center;
    tbody {
      // background: #fff;
      color: #333;
    }
    &.allowscroll {
      > tbody {
        display: block;
        overflow: auto;
      }
      > thead,
      > tbody {
        > tr {
          display: table;
          width: 100%;
          table-layout: fixed;
        }
      }
    }
  }
}
.thead {
  // tr {
  //   th {
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //   }
  // }
  th {
    height: 38px;
    font-weight: normal;
    font-size: 12px;
    background: rgb(53, 110, 236);
    opacity: 0.7;
    text-align: center;
    color: #fff;
    &:first-child {
      border-radius: 10px 0 0 0;
      text-align: left;
      padding-left: 30px;
    }
    &:last-child {
      border-radius: 0 10px 0 0;
    }
  }
}
tr {
  border-bottom: 1px solid #f0f1f9;
}
td {
  padding: 10px 15px;
  &:first-child {
    text-align: left;
    padding-left: 30px;
  }
  &.msg {
    text-align: center;
    padding: 30px 15px;
  }
}
.listmsg {
  text-align: center;
  line-height: 30px;
}

.gridpager {
  margin-top: 45px;
  margin-bottom: 20px;
  .ctrl {
    text-align: center;
    span {
      cursor: pointer;
      display: inline-block;
      line-height: 22px;
      padding: 0 10px;
      margin: 0 5px;
      color: #333;
      border-radius: 4px;
      &.active,
      &:hover {
        text-decoration: none;
        background: #5e8ffc;
        color: #fff;
      }
    }
  }
}
.more {
  text-align: center;
  font-size: 14px;
  color: #5e8ffc;
  cursor: pointer;
  margin-top: 30px;
}
</style>
